import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from './routes';
import { ToastContainer } from '@/components/ui/Toast';
import { useAuthStore } from '@/stores/authStore';
import { DEFAULT_PRIMARY } from '@/hooks/useBranding';
import i18n from '@/i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
});

function AuthBootstrap() {
  const bootstrap = useAuthStore((s) => s.bootstrap);
  const status = useAuthStore((s) => s.status);
  const primaryColor = useAuthStore((s) => s.user?.company?.primary_color ?? null);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  // Inject brand CSS variable whenever primary_color changes.
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--brand-primary',
      primaryColor ?? DEFAULT_PRIMARY,
    );
  }, [primaryColor]);

  if (status === 'idle' || status === 'loading') {
    return (
      <div
        className="flex h-screen items-center justify-center"
        aria-label={i18n.t('common:aria.loadingApplication')}
        aria-busy="true"
      >
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-indigo-600 border-t-transparent" />
      </div>
    );
  }

  return <RouterProvider router={router} />;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthBootstrap />
      <ToastContainer />
    </QueryClientProvider>
  );
}
